import React, { useState, useEffect, forwardRef, useRef } from "react";
import { EmailShareButton, FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";
import { MdOutlineEmail } from "react-icons/md";
import { FaFacebook , FaXTwitter, FaLinkedin } from "react-icons/fa6";
import classNames from "classnames";
import IStyledProps from "../../utilities/IStyledProps";
import styled from "styled-components";

export interface IBlogSocials extends IStyledProps {
    url?: string;
    size: number;
}

const BlogSocials = (props: IBlogSocials) => {
    const { className, url, size } = props;

    return (
        <div className={classNames('text-white', className)}>
            <div className="text-center text-uppercase" ><small style={{fontSize: '12px', fontWeight: 400}}>Share this article</small></div>
            <div className="mt-1 rounded-pill bg-opacity-10 blur shadow p-2 d-flex justify-content-between">
                <FacebookShareButton url={url} >
                    <FaFacebook size={size} />
                </FacebookShareButton>
                <TwitterShareButton url={url} >
                    <FaXTwitter size={size} />
                </TwitterShareButton>
                <LinkedinShareButton url={url}>
                    <FaLinkedin size={size} />
                </LinkedinShareButton>
                <EmailShareButton url={url}>
                    <MdOutlineEmail size={size} />
                </EmailShareButton>
            </div>

        </div>
    );
};

export default styled(BlogSocials)`
    width: 180px;
`;